import { render, staticRenderFns } from "./AddSubCategories.vue?vue&type=template&id=23403f14&"
import script from "./AddSubCategories.vue?vue&type=script&lang=js&"
export * from "./AddSubCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports